import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

class Submission {
  async submitData(payload) {
    let { data } = await axios.post(API_URL + '/submissions/data', payload);
    return data;
  }

  async getCategories() {
    let { data } = await axios.get(API_URL + '/submissions/categories');
    return data;
  }

  async createPost(payload) {
    // payload: { content, channel, parent_id, bulk_attribution, bulk_category, items[] }
    let { data } = await axios.post(API_URL + '/submissions/data', payload);
    return data;
  }

  async createComment(parentId, payload) {
    // Create a comment by including parent_id in the payload
    const commentPayload = {
      ...payload,
      parent_id: parentId
    };
    let { data } = await axios.post(API_URL + '/submissions/data', commentPayload);
    return data;
  }

  async getSubmissionComments(submissionId, offset = 0, limit = 20) {
    const params = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
    });
    let { data } = await axios.get(`${API_URL}/submissions/${submissionId}/comments?${params}`);
    return data;
  }

  async getSubmissionsFeed(offset = 0, limit = 20) {
    const params = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
    });
    let { data } = await axios.get(`${API_URL}/submissions/feed?${params}`);
    return data;
  }

  async getSubmission(submissionId) {
    let { data } = await axios.get(`${API_URL}/submissions/${submissionId}`);
    return data;
  }

  async getSubmissionAttachments(submissionId, offset = 0, limit = 20) {
    const params = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
    });
    let { data } = await axios.get(`${API_URL}/submissions/${submissionId}/attachments?${params}`);
    return data;
  }

  async getSubmissionData(submissionId, offset = 0, limit = 20) {
    const params = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
    });
    let { data } = await axios.get(`${API_URL}/submissions/${submissionId}/data?${params}`);
    return data;
  }

  async getSubmissionAttachmentsAggregated(submissionId, offset = 0, limit = 20) {
    const params = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
    });
    let { data } = await axios.get(`${API_URL}/submissions/${submissionId}/attachments/aggregated?${params}`);
    return data;
  }

  async getSubmissionAttachmentsAggregatedCount(submissionId) {
    let { data } = await axios.get(`${API_URL}/submissions/${submissionId}/attachments/aggregated/count`);
    return data;
  }

  async getSubmissionDataAggregated(submissionId, offset = 0, limit = 20) {
    const params = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
    });
    let { data } = await axios.get(`${API_URL}/submissions/${submissionId}/data/aggregated?${params}`);
    return data;
  }

  async getSubmissionDataAggregatedCount(submissionId) {
    let { data } = await axios.get(`${API_URL}/submissions/${submissionId}/data/aggregated/count`);
    return data;
  }

  async uploadFiles(submissionId, formData) {
    try {
      let { data } = await axios.post(`${API_URL}/submissions/${submissionId}/files`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 60000
      });
      return data;
    } catch (error) {
      console.error('File upload error:', error);
      throw error;
    }
  }

  async downloadAttachment(submissionId, attachmentId) {
    try {
      const response = await axios.get(`${API_URL}/submissions/${submissionId}/attachments/${attachmentId}/download`, {
        responseType: 'blob',
        timeout: 60000
      });
      return response;
    } catch (error) {
      console.error('File download error:', error);
      throw error;
    }
  }
}

export default new Submission();
